























import {Component, Vue} from 'vue-property-decorator';
import UserTable from "@/components/admin/UsersTable.vue";
import RoleTable from "@/components/admin/RoleTable.vue";
import {currentUserModule} from "@/store";

@Component({
    name: 'UsersAdmin',
    components: {
        UserTable,
        RoleTable
    }
})
export default class UsersEditor extends Vue {
    get canSeeUsers(){
        return currentUserModule.hasRight("UserGetAllCmd")
    }

    get canSeeRoles(){
        return currentUserModule.hasRight("RoleCreateCmd") ||
            currentUserModule.hasRight("RoleUpdateCmd")
    }

    async mounted() {
        await currentUserModule.load();
    }
}
